import allUrls from '@/utils/config'

const config = {
  cn: {
    iuoploginUrl: allUrls.iuoploginUrl,
    iuopLoginingUrl: allUrls.iuopLoginingUrl,
  },
  sg: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  my: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  in: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  eu: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  th: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  id: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  ph: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  vn: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  jp: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  au: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  kr: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  gb: {
    iuoploginUrl: allUrls.iuopGloballoginUrl,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl,
  },
  us: {
    iuoploginUrl: allUrls.iuopGloballoginUrl_us,
    iuopLoginingUrl: allUrls.iuopGlobalLoginingUrl_us,
  },
}

export default config
